const lowerApp = ( () =>
{
	let scrollObserver;
	let elMainDisplay;

	const CONFIG = {
		selectors: {
			mainDisplay: '.mainDisplay',
			anchorContent: '.anchorContent',
			observee: '.js-observee',
			navPrimary: '.nav-side .link-primary',
			pageTitle: '.pageTitle',
		},
		observer: {
			rootMargin: '0px 0px -10% 0px',
			threshold: 0
		},
	};

	/**
	 * 初期化
	 */
	const init = () =>
	{
		elMainDisplay = document.querySelector( CONFIG.selectors.mainDisplay );
		
		initSideNav();
		initScrollAnimation();
		initLayout();
	};
	
	/**
	 * レイアウト調整 .pageTitleのheightセット
	 */
	const initLayout = () =>
	{
		const container = document.querySelector( '.l-container' );
		const title = document.querySelector( CONFIG.selectors.pageTitle );

		if ( !container ) return;

		const adjustSideNavPosition = () =>
		{
			container.style.removeProperty( '--pageTitle-height' );
			const titleHeight = title ? title.offsetHeight : 0;
			container.style.setProperty( '--pageTitle-height', `${titleHeight}px` );
		};

		adjustSideNavPosition();
		window.addEventListener( 'resize', adjustSideNavPosition );
	};

	/**
	 * サイドナビ
	 */
	const initSideNav = () =>
	{
		const navButtons = document.querySelectorAll( CONFIG.selectors.navPrimary );

		navButtons.forEach( button =>
		{
			button.addEventListener( 'click', () => toggleAccordion( button ) );
		} );

		window.addEventListener( 'hashchange', switchContentByHash );

		// 初回読み込み時のハッシュ処理
		switchContentByHash();
	};

	/**
	 * アコーディオンの開閉
	 */
	const toggleAccordion = ( button ) =>
	{
		const parentLi = button.parentElement;
		const siblingLis = parentLi.parentElement.children;
		
		Array.from( siblingLis ).forEach( li =>
		{
			if( li !== parentLi ) li.classList.remove( 'is-open' );
		} );
		
		parentLi.classList.toggle( 'is-open' );
	};

	/**
	 * ハッシュに基づいたコンテンツ切り替え
	 */
	const switchContentByHash = () =>
	{
		const hash = window.location.hash;
		const contents = document.querySelectorAll( CONFIG.selectors.anchorContent );
		
		let targetElement;
		if( hash )
		{
			const targetId = hash.replace( '#', '' );
			targetElement = document.getElementById( targetId );
		}
		else
		{
			targetElement = contents[0];
		}

		if( !targetElement || !targetElement.classList.contains( 'anchorContent' ) ) return;

		// すべてのコンテンツの非アクティブ化
		contents.forEach( content =>
		{
			content.classList.remove( 'is-active' );
		} );

		requestAnimationFrame( () =>
		{
			// ターゲットをアクティブにしてアニメーションをリセット
			targetElement.classList.add( 'is-active' );
			resetObservee( targetElement );

			// ウインドウと、独立スクロールするメインエリアを強制的に最上部へ戻す
			window.scrollTo( { top: 0, behavior: 'instant' } );
			if( elMainDisplay )
			{
				elMainDisplay.scrollTo( { top: 0, behavior: 'instant' } );
			}
		} );
	};

	/**
	 * スクロールアニメーション
	 */
	const initScrollAnimation = () =>
	{
		const targets = document.querySelectorAll( CONFIG.selectors.observee );

		scrollObserver = new IntersectionObserver( ( entries ) =>
		{
			entries.forEach( entry =>
			{
				if( entry.isIntersecting )
				{
					entry.target.classList.add( 'is-visible' );
					scrollObserver.unobserve( entry.target );
				}
			} );
		}, CONFIG.observer );

		targets.forEach( target => scrollObserver.observe( target ) );
	};

	/**
	 * アニメーションのリセット
	 */
	const resetObservee = ( parent ) =>
	{
		const targets = parent.querySelectorAll( CONFIG.selectors.observee );

		targets.forEach( target =>
		{
			target.classList.remove( 'is-visible' );
			if( scrollObserver )
			{
				scrollObserver.unobserve( target );
				scrollObserver.observe( target );
			}
		} );
	};

	return {
		init: init
	};
} )();

document.addEventListener( 'DOMContentLoaded', () =>
{
	lowerApp.init();
} );